// Pure display formatters — no DOM, no state mutation.
import { state } from "../state.js";
import { supabase } from "../supabase-client.js";

export function difficultyDisplay(level) {
  const normalized = Math.min(10, Math.max(1, Number(level) || 1));
  return normalized <= 2
    ? (state.language === "it" ? "Base" : "Basic")
    : normalized <= 5
      ? (state.language === "it" ? "Medio" : "Intermediate")
      : normalized <= 8
        ? (state.language === "it" ? "Avanzato" : "Advanced")
        : (state.language === "it" ? "Esperto" : "Expert");
}

export function difficultySymbol(level) {
  const normalized = Math.min(10, Math.max(1, Number(level) || 1));
  if (normalized <= 2) return "🌱";
  if (normalized <= 5) return "⭐";
  if (normalized <= 8) return "🚀";
  return "🏆";
}

export function localizedExerciseCount(count) {
  const value = Number(count || 0);
  const label = state.language === "it"
    ? (value === 1 ? "attività" : "attività")
    : (value === 1 ? "activity" : "activities");
  return `${value} ${label}`;
}

export function moneyEUR(value) {
  return `€${Number(value || 0).toFixed(2)}`;
}

export function moneyCents(value) {
  return `€${(Number(value || 0) / 100).toFixed(2)}`;
}

export function platformCostCategoryLabel(category) {
  const labels = {
    supabase: "Supabase",
    netlify: "Netlify",
    openai: "OpenAI",
    email: state.language === "it" ? "Email" : "Email",
    domain: state.language === "it" ? "Dominio" : "Domain",
    apple: "Apple",
    other: state.language === "it" ? "Altro" : "Other"
  };
  return labels[category] || category || "—";
}

export function betaRequestStatusLabel(status) {
  const labels = state.language === "it"
    ? { pending: "In attesa", approved: "Approvata", rejected: "Rifiutata", more_info: "Informazioni richieste", blocked: "Bloccata" }
    : { pending: "Pending", approved: "Approved", rejected: "Rejected", more_info: "More information", blocked: "Blocked" };
  return labels[status] || status;
}

export function difficultyBandInfo(level) {
  const numeric = Number(level || 1);
  if (numeric <= 2) return { code: "base", label: state.language === "it" ? "Base" : "Basic", icon: "🌱" };
  if (numeric <= 5) return { code: "medio", label: state.language === "it" ? "Medio" : "Intermediate", icon: "⭐" };
  if (numeric <= 8) return { code: "avanzato", label: state.language === "it" ? "Avanzato" : "Advanced", icon: "🚀" };
  return { code: "esperto", label: state.language === "it" ? "Esperto" : "Expert", icon: "🏆" };
}

export function topicDisplayInfo(topic) {
  const rawParts = String(topic || "").split(">").map(part => part.trim()).filter(Boolean);
  const fallback = state.language === "it" ? "Senza tema" : "No topic";
  const title = rawParts.length ? rawParts[rawParts.length - 1] : fallback;
  const macro = rawParts.length > 1 ? rawParts[0] : "";
  return {
    key: title.toLocaleLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").replace(/\s+/g, " ").trim(),
    title,
    macro
  };
}

export function formatSeconds(seconds) {
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
}
